import { parsePhoneNumberFromString } from "libphonenumber-js";

/**
 * Normalizes any input ("+1 786-655-3369", "17866553369", "(786) 655 3369")
 * to the 10-digit US national number. Leading 0/1 are dropped because a US
 * area code never starts with them (a leading 1 is the country code).
 */
export function toUSDigits(input: string): string {
  return input.replace(/\D/g, "").replace(/^[01]+/, "").slice(0, 10);
}

/** Progressive display format: (786) 655-3369 */
export function formatUSPhone(digits: string): string {
  const d = digits.slice(0, 10);
  if (d.length === 0) return "";
  if (d.length <= 3) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}

/** +17866553369 — format sent to the CRM and the calendar. */
export function toE164(digits: string): string {
  const d = toUSDigits(digits);
  return d.length === 10 ? `+1${d}` : "";
}

/** Returns an error message, or null if it is a valid US number. */
export function validateUSPhone(digits: string): string | null {
  const d = toUSDigits(digits);
  if (d.length < 10) return "Escribe los 10 dígitos de tu número (ej. 786 555 1234).";

  const area = d.slice(0, 3);
  const exchange = d.slice(3, 6);
  const line = d.slice(6);
  const invalid =
    /^[01]/.test(exchange) || // exchange can't start with 0/1
    /^\d11$/.test(area) || // N11 service codes (411, 911…)
    /^\d11$/.test(exchange) ||
    area === "555" ||
    (exchange === "555" && /^01\d\d$/.test(line)) || // fictional 555-01XX
    /^(\d)\1{9}$/.test(d); // all the same digit

  if (invalid) return "Este número no es válido en Estados Unidos.";

  const parsed = parsePhoneNumberFromString(`+1${d}`, "US");
  if (!parsed || !parsed.isValid() || parsed.country !== "US") {
    return "Usa un número de Estados Unidos (+1).";
  }
  return null;
}
